import { types } from 'mobx-state-tree';

import Calendar from './Calendar/calendar';
import Actions from './Actions';
import Analytics from './Analytics';
import Billing from './Billing';
import Company from './Company';
import FreeTrial from './FreeTrial';
import IdleTimeout from './IdleLogout';
import UBP from './UBP';
import Views from './Views';

export const UserProps = {
  id: types.maybe(types.integer),
  accountId: types.maybe(types.integer),
  firstName: types.maybe(types.string),
  lastName: types.maybe(types.string),
  countryCode: types.maybe(types.string),
  availableCredits: types.optional(types.integer, 0),
  totalCredits: types.optional(types.integer, 0),
  groupName: types.maybeNull(types.string),
  email: types.maybe(types.string),
  phone: types.maybe(types.string),
  hashedEmail: types.maybe(types.string),
  industry: types.maybe(types.string),
  accountStatus: types.maybe(types.string),
  accountStatusReason: types.maybe(types.string),
  accountDomain: types.maybe(types.string),
  isLoaded: types.optional(types.boolean, false),
  isFirstShow: types.maybe(types.boolean),
  isFirstOutOfCredits: types.maybe(types.boolean),
  isAccountAdmin: types.optional(types.boolean, false),
  isAccountIntegrationLoaded: types.optional(types.boolean, false),
  features: types.optional(types.array(types.optional(types.string, '')), []),
  bulkAvailableCredits: types.optional(types.integer, 0),

  freeTrial: types.maybeNull(FreeTrial),
  billing: types.maybeNull(Billing),
  company: types.optional(Company, () => Company.create()),
  analytics: types.optional(Analytics, () => Analytics.create()),
  roleId: types.maybeNull(types.integer),

  activeIntegrations: types.optional(types.array(types.string), []),
  calendarSettings: types.optional(Calendar, () => Calendar.create()),
  recordFullstorySession: types.optional(types.boolean, () => Math.random() >= 0.8),
  idleTimeout: types.optional(IdleTimeout, () => IdleTimeout.create()),

  ubp: types.maybeNull(UBP),
  isSearchByDataPointEnabled: types.optional(types.boolean, false),
  accountIntentTopicsCount: types.optional(types.number, 0),
  accountIntentTopicsLoaded: types.optional(types.boolean, false),
  accountUnfreezeDate: types.optional(types.string, ''),
  subscriptionStatus: types.optional(types.string, ''),
};

const User = types.model(UserProps).actions(Actions).views(Views);

export default User;
